import { Component, Input } from "@angular/core";
import { IndexSection } from "../store/product-index/state";
import { Environment } from "./environment";
import { ConfirmModalComponent } from "../components/modals/confirm-modal.component";
import { Division } from "../services/consultation.service";
import { trackIndexSection } from "../utils/utils";

@Component({
    selector:
        "[picker-selection-section], [picker-selection-product], picker-selection-section",
    templateUrl: "picker-selection-section.component.html",
    styleUrls: ["picker-selection-section.component.css"],
})
export class PickerSelectionSectionComponent {
    @Input() env: Environment;
    @Input() section: IndexSection;
    @Input() root = true;

    trackSection = trackIndexSection;

    removeDivision(div: Division) {
        ConfirmModalComponent.open(
            `Möchten Sie das Produkt '${div.Name}' löschen?`,
            () => {
                this.env.persistence.deleteManualDivision(div);
                if (div.ProductKey === "privatrechtsschutz") {
                    this.removeEirweiterRS(div);
                }
            },
        );
    }

    removeEirweiterRS(div: Division) {
        const erweiterIndex = Number(div.Label.match(/\d+$/)[0]);
        this.env.protocol.Offers.forEach((offer) => {
            offer.Divisions.forEach((division) => {
                const index = Number(division.Label.match(/\d+$/)[0]);
                const key = division.ProductKey;
                if (
                    index === erweiterIndex &&
                    key === "erweiterterstrafrechtsschutz"
                ) {
                    this.env.persistence.deleteManualDivision(division);
                }
            });
        });
    }

    get filteredSection(): IndexSection {
        return this.root ? filterSectionRec(this.section) : this.section;
    }

    get type(): SelectionSectionType {
        return this.getSectionType(this.filteredSection);
    }

    getSectionType(section): SelectionSectionType {
        return section.instances.length ? "product" : "section";
    }
}

function filterSectionRec(section: IndexSection): IndexSection {
    const filteredItems = section.items
        .map((subSection) => filterSectionRec(subSection))
        .filter(
            (subSection) =>
                (subSection.items && subSection.items.length) ||
                (subSection.instances && subSection.instances.length),
        );

    return Object.assign({}, section, { items: filteredItems });
}

type SelectionSectionType = "section" | "product";
